import Alpine from 'alpinejs'
import collapse from "@alpinejs/collapse";
import Swiper, {
    Navigation,
    Pagination,
    Thumbs,
    EffectFade,
    Mousewheel,
    FreeMode,
    Autoplay,
  } from "swiper";
  
  import "swiper/css";
  import "swiper/css/navigation";
  import "swiper/css/pagination";
  import "swiper/css/effect-fade";
  
  Swiper.use([Autoplay, Pagination, Navigation, Thumbs, EffectFade, Mousewheel, FreeMode]);
  window.Swiper = Swiper;
Alpine.plugin(collapse);
window.Alpine = Alpine

Alpine.start()
// ancor link funzione per scroll lento
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});